<script setup>
  import { version as projectVersion } from '~~/package.json'
</script>

<template>
  <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <span class="absolute bottom-0 left-0 p-3 text-sm text-gray-600">
      {{ `v${projectVersion}` }}
    </span>
    <slot />
  </div>
</template>